import { firebaseClient } from "firebaseClient";

export async function getRecentPosts(limit = 5, nbPostMultiplier = 5, linkedinUsername = null, linkedInId = null, dashEntityUrn = null, firebaseServer = firebaseClient) {
    if (!linkedinUsername && !linkedInId && !dashEntityUrn) return [];

    const db = firebaseServer.firestore();

    let docs;
    const posts: any = [];
    const fetchLimit = limit * nbPostMultiplier;
    try {
        docs = await db
            .collection("linkedinPosts")
            .where("user.id", "==", linkedInId)
            .orderBy("created_at", "desc")
            .limit(fetchLimit) //fetches extra posts to fill up 5 posts limit if possible, since we only show posts where numComments > 0
            .get();

        if (docs.size < fetchLimit) {
            docs = await db
                .collection("linkedinPosts")
                .where("user.username", "==", linkedinUsername)
                .orderBy("created_at", "desc")
                .limit(fetchLimit)
                .get();
        }

        docs.forEach((doc) => {
            let tw = doc.data();
            posts.push(tw);
        });
    } catch (e) {
        console.log('Error occured while fetching posts for reply-comments. For user with id:', linkedInId, 'dashEntityUrn', dashEntityUrn, 'username', linkedinUsername, e);
    }

    return posts;

}

export const getPostFromIdShort = async (idShort, firebaseServer = firebaseClient) => {
    if (!idShort) return;

    const db = firebaseServer.firestore();

    let docs;
    const post: any = [];

    try {

        docs = await db
            .collection("linkedinPosts")
            .where("idShort", "==", idShort)
            .get();

        post.push(await docs.docs?.[0]?.data());

    } catch (e) {
        console.log('Error occured while fetching single post for reply-comments. with idShort' + idShort, e);
    }
    return post;
}